import { ButtonHTMLAttributes, FC } from 'react'

import { cn } from '@/app/utils'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { active?: boolean }

const PaginationButtonPage: FC<Props> = ({
  className,
  active,
  children,
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn(
        'flex h-40 w-40 items-center justify-center rounded-8 font-pro' +
          'text-grey-70 text-14 hover:bg-grey-100/5 hover:transition active:bg-grey-100/10 xs:h-36 xs:w-36 xxs:h-30 xxs:w-30',
        active && 'border border-grey-20 bg-white font-sans font-bold',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default PaginationButtonPage
